/* eslint-disable quotes, quote-props, comma-dangle  */

const translations = {
  "close-label": [{
    "type": 0,
    "value": "Close"
  }],
  "open-the-help-dropdown": [{
    "type": 0,
    "value": "Open the help dropdown"
  }],
  "open-the-help-panel": [{
    "type": 0,
    "value": "Open the help panel"
  }]
};
function TranslationProviderComponent({
  children
}) {
  return children(translations);
}
var DefaultTranslationComp = Object.assign(TranslationProviderComponent, {
  translations
});

export { DefaultTranslationComp as D };
//# sourceMappingURL=en-US-CWe_aZNZ.js.map
